export default "__VITE_ASSET__CHeDn_JM__"